import { applyCompleteStepBody } from 'app/ui/sai-quick-tour/sai-quick-tour-complete.util';
import { SaiQuickTourStep } from 'app/ui/sai-quick-tour/sai-quick-tour.types';

/**
 * Whether the signed-in user may access a tour step gated on a module permission.
 * Matches `PermissionGuard` / `getPermissionsForGuard()` semantics (`true`, `full_access`, `read_only`).
 */
export function hasTourModulePermission(
    perms: Record<string, unknown> | null | undefined,
    permissionKey: string,
): boolean {
    const raw = perms?.[permissionKey];
    if (raw === true) {
        return true;
    }
    const normalized = String(raw ?? '')
        .trim()
        .toLowerCase();
    return normalized === 'full_access' || normalized === 'read_only';
}

/** Drop steps whose `permissionKey` is absent from the caller's entitlements. */
export function filterTourStepsByPermission(
    steps: readonly SaiQuickTourStep[],
    perms: Record<string, unknown> | null | undefined,
): readonly SaiQuickTourStep[] {
    const permitted = steps.filter(
        (step) => !step.permissionKey || hasTourModulePermission(perms, step.permissionKey),
    );
    return applyCompleteStepBody(permitted);
}
